import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../state/AuthContext";

// Usage: export default withAuthGuard(MyComponent)
export default function withAuthGuard(WrappedComponent, redirectTo = "/login") {
  return function AuthGuardedComponent(props) {
    const { isLoggedIn } = useAuth();
    const location = useLocation();

    if (!isLoggedIn) {
      // Optionally, pass the intended location for post-login redirect
      return <Navigate to={redirectTo} replace state={{ from: location }} />;
    }

    return <WrappedComponent {...props} />;
  };
}